import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white/90 backdrop-blur-md shadow-lg border-b border-teal-100' 
        : 'bg-transparent'
    }`}>
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_aquaclean-hub/artifacts/vrwnd2yr_ChatGPT%20Image%2013%20oct.%202025%2C%2009_26_05.png"
              alt="Good-Bloom Logo"
              className="w-12 h-12 object-contain"
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-teal-700 to-cyan-600 bg-clip-text text-transparent">
              Good-Bloom
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('accueil')}
              className="text-gray-700 hover:text-teal-600 transition-colors duration-200 font-medium"
            >
              Accueil
            </button>
            <button 
              onClick={() => scrollToSection('technologies')}
              className="text-gray-700 hover:text-teal-600 transition-colors duration-200 font-medium"
            >
              Technologies
            </button>
            <button 
              onClick={() => scrollToSection('realisations')}
              className="text-gray-700 hover:text-teal-600 transition-colors duration-200 font-medium"
            >
              Réalisations
            </button>
            <button 
              onClick={() => scrollToSection('rendez-vous')}
              className="text-gray-700 hover:text-teal-600 transition-colors duration-200 font-medium"
            >
              Rendez-vous
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white px-6 py-2 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              Contact
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white/95 backdrop-blur-md rounded-lg shadow-xl border border-teal-100 animate-in slide-in-from-top duration-200">
            <div className="flex flex-col space-y-4 px-4">
              <button 
                onClick={() => scrollToSection('accueil')}
                className="text-left text-gray-700 hover:text-teal-600 transition-colors duration-200 font-medium py-2"
              >
                Accueil
              </button>
              <button 
                onClick={() => scrollToSection('technologies')}
                className="text-left text-gray-700 hover:text-teal-600 transition-colors duration-200 font-medium py-2"
              >
                Technologies
              </button>
              <button 
                onClick={() => scrollToSection('realisations')}
                className="text-left text-gray-700 hover:text-teal-600 transition-colors duration-200 font-medium py-2"
              >
                Réalisations
              </button>
              <button 
                onClick={() => scrollToSection('rendez-vous')}
                className="text-left text-gray-700 hover:text-teal-600 transition-colors duration-200 font-medium py-2"
              >
                Rendez-vous
              </button>
              <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white px-6 py-3 rounded-full transition-all duration-300 mt-2"
              >
                Contact
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;